import { createAction } from 'redux-actions';
import { callApi, getEndpoint } from '../../../../utils/api';
import {
  BUY_TRANSACTION,
  COLLEGE_CONTRIBUTE_TRANSACTION,
  COLLEGE_DISTRIBUTE_TRANSACTION,
  COLLEGE_EXCHANGE_TRANSACTION,
  EXCHANGE_TRANSACTION,
  ROTH_CONVERSION,
  isCollegeAnything,
  SELL_TRANSACTION,
  transactionType,
} from '../../../../utils/transactions-util';
import { TransactionTypes } from '../../../../settings/settings';

const GET_USER_REGISTRATION_TYPE = 'GET_USER_REGISTRATION_TYPE';
const SET_USER_REGISTRATION_TYPE = 'SET_USER_REGISTRATION_TYPE';

export default function userRegistrationTypeInfo(
  state = {
    isLoading: false,
    isLoaded: false,
    hasFailed: false,
    registrationTypes: {},
    error: false,
    selectedRegistrationType: {},
  },
  { payload, type }
) {
  switch (type) {
    case `${GET_USER_REGISTRATION_TYPE}_PENDING`:
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
      };

    case `${GET_USER_REGISTRATION_TYPE}_FULFILLED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        registrationTypes: payload.body,
      };

    case `${GET_USER_REGISTRATION_TYPE}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        hasError: true,
        registrationTypes: {},
        error: payload,
      };

    case `${SET_USER_REGISTRATION_TYPE}_FULFILLED`:
      return {
        ...state,
        selectedRegistrationType: payload,
      };
    default:
      return state;
  }
}

export const getRegistrationTypes = (type = 'Purchase') => {
  switch (transactionType()) {
    case BUY_TRANSACTION:
      type = TransactionTypes.BUY;
      break;
    case EXCHANGE_TRANSACTION:
      type = TransactionTypes.EXCHANGE;
      break;
    case SELL_TRANSACTION:
      type = TransactionTypes.SELL;
      break;
    case COLLEGE_CONTRIBUTE_TRANSACTION:
      type = TransactionTypes.BUY;
      break;
    case COLLEGE_DISTRIBUTE_TRANSACTION:
      type = TransactionTypes.SELL;
      break;
    case COLLEGE_EXCHANGE_TRANSACTION:
      type = TransactionTypes.EXCHANGE;
      break;
    case ROTH_CONVERSION:
      type = TransactionTypes.ROTH_CONVERSION;
      break;
    default:
      console.error(
        'Unexpected transaction type for getRegestrationTypes: ' +
          transactionType()
      );
      type = TransactionTypes.BUY;
  }
  return (dispatch) => {
    const action = createAction(GET_USER_REGISTRATION_TYPE)(
      callApi(
        `${getEndpoint('registration')}?productType=${
          isCollegeAnything() ? 'CollegeSavings' : 'mutualFund'
        }&transactionType=${type}`
      )
    );
    dispatch(action);
  };
};

export const setRegistrationTypes = (selectedRegistration) => {
  return (dispatch) => {
    const action = createAction(`${SET_USER_REGISTRATION_TYPE}_FULFILLED`)(
      selectedRegistration
    );
    dispatch(action);
  };
};
